import { createReducer } from '@reduxjs/toolkit';
import * as actionTypes from 'modules/customers/actionTypes';

/**
 * @typedef {{[id: string]: import('types/Global').Customer}} ByIdState
 */

/** @type {ByIdState} */
const initialState = {};

/**
 * @param {ByIdState} state
 * @param {PostUnsubscribeSuccessAction} action
 * @returns {ByIdState}
 */
const update = (state, { payload }) => ({
  ...state,
  [payload.customerInfo?.id]: payload.customerInfo,
});

export default createReducer(initialState, (builder) => {
  builder.addCase(actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE_SUCCESS, update);
});
